module.exports = "/_next/static/images/profile-image--default-c24af55691490b49c554775cf1c92572.png";